import { FormError, Input } from '@/components'
import { ChangeEvent, forwardRef, useEffect } from 'react'
import { checkisCoupon } from '@/helpers/checkIsCoupon'
import styles from './FindCarInput.module.scss'

type FindCarInputProps = {
  value: string
  isOnlyCarNumber: boolean
  onChange: (value: string) => void
  error?: string
}

export const FindCarInput = forwardRef<HTMLInputElement, FindCarInputProps>(
  ({ value, error, isOnlyCarNumber, onChange }, ref) => {

    useEffect(() => {
      if (ref && 'current' in ref) {
        ref.current?.focus()
      }
    }, [ref])

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value.replace(/\s/g, '')
      const isCoupon = checkisCoupon(value)
      const valueAsArray = value.split('')

      if (isCoupon && valueAsArray.length > 3 && valueAsArray[3] !== ' ') {
        valueAsArray.splice(3, 0, ' ')
      }

      if (isCoupon && valueAsArray.length > 7 && valueAsArray[7] !== ' ') {
        valueAsArray.splice(7, 0, ' ')
      }

      value = valueAsArray.join('')
      onChange(value)
    }

    return (
      <div className={styles.container}>
        <FormError error={error} className={styles.input__error}>
          <Input
            value={value.toUpperCase()}
            onChange={onInputChange}
            ref={ref}
            placeholder={isOnlyCarNumber ? 'A012BC123' : 'А012ВС12 или 312 755 7900'}
            danger={!!error}
            className={styles.input}
          />
        </FormError>
      </div>
    )
  },
)
